const naped = { t: 'Napęd', name: 'naped', hint: { url: '/drive' }}
export default naped